import api from '@/utils/api'

// 仅统计此类型的未读数 (与后端 driver_message.type 对齐)
const POLL_TYPE = 'force_dispatch'
// 轮询间隔 (ms)
const POLL_INTERVAL = 60 * 1000
// 单次拉取未读详情上限 (避免一次弹出几百条)
const POLL_LIST_SIZE = 50

const state = {
  unreadCount: 0,
  // 待弹窗队列: 每次轮询发现新的 force_dispatch 未读就 push 进来
  pendingNotifications: [],
  // 已弹过的消息 id, 防止重复弹出 (仅在内存, 刷新后重置)
  shownIds: [],
  pollingTimer: null
}

const mutations = {
  SET_UNREAD_COUNT: (state, count) => { state.unreadCount = count },
  SET_POLLING_TIMER: (state, timer) => { state.pollingTimer = timer },
  PUSH_PENDING: (state, list) => {
    // 替换引用, 保证 watcher 触发
    state.pendingNotifications = state.pendingNotifications.concat(list)
  },
  CLEAR_PENDING: (state) => { state.pendingNotifications = [] },
  MARK_SHOWN: (state, ids) => {
    for (const id of ids) {
      if (id != null && !state.shownIds.includes(id)) {
        state.shownIds.push(id)
      }
    }
  }
}

const actions = {
  // 拉未读数 (用于 badge) + 若有未读再拉详情 (用于弹窗)
  fetchUnreadCount({ commit, dispatch, state }) {
    if (!localStorage.getItem('tokenVue')) return Promise.resolve()
    return api({
      url: '/driverMessage/unreadCount',
      method: 'post',
      data: { type: POLL_TYPE }
    }).then(res => {
      if (res.status === 0) {
        const count = res.data || 0
        commit('SET_UNREAD_COUNT', count)
        if (count > 0) {
          return dispatch('fetchUnreadDetails')
        }
      }
    }).catch(() => { /* 静默失败, 下个轮询周期重试 */ })
  },

  // 拉未读消息详情, 找出本轮新增的推入 pendingNotifications
  fetchUnreadDetails({ commit, state }) {
    return api({
      url: '/driverMessage/list',
      method: 'post',
      data: { type: POLL_TYPE, pageNum: 1, pageSize: POLL_LIST_SIZE }
    }).then(res => {
      if (res.status === 0) {
        const list = (res.data && res.data.list) || []
        const unread = list.filter(m => m.isRead === 0)
        const shownSet = new Set(state.shownIds)
        const newUnread = unread.filter(m => !shownSet.has(m.id))
        if (newUnread.length > 0) {
          commit('PUSH_PENDING', newUnread)
          commit('MARK_SHOWN', newUnread.map(m => m.id))
        }
      }
    }).catch(() => { /* 静默失败 */ })
  },

  // 开启轮询
  startPolling({ dispatch, commit, state }) {
    if (state.pollingTimer) return  // 防止重复开启
    dispatch('fetchUnreadCount')     // 立即拉一次
    const timer = setInterval(() => {
      dispatch('fetchUnreadCount')
    }, POLL_INTERVAL)
    commit('SET_POLLING_TIMER', timer)
  },

  // 停止轮询 (登出时调用)
  stopPolling({ commit, state }) {
    if (state.pollingTimer) {
      clearInterval(state.pollingTimer)
      commit('SET_POLLING_TIMER', null)
    }
  },

  // 标记已读后, 本地 -1
  decrementUnread({ commit, state }) {
    if (state.unreadCount > 0) {
      commit('SET_UNREAD_COUNT', state.unreadCount - 1)
    }
  },

  // 全部已读后, 本地归零
  resetUnread({ commit }) {
    commit('SET_UNREAD_COUNT', 0)
  },

  // 弹窗显示完成后清空队列
  clearPending({ commit }) {
    commit('CLEAR_PENDING')
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/notification.js